import React from 'react';
import { Link } from 'react-router-dom';
import { Logo, Button } from '../ui';
import { ParticipantPreview } from './ParticipantPreview';
import { ArrowLeftIcon, ExternalLinkIcon, QrCodeIcon, CopyIcon } from 'lucide-react';
export function EventHubPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-1420">
      {/* Top bar */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-20" data-id="element-1421">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4" data-id="element-1422">
          <div className="flex items-center gap-4" data-id="element-1423">
            <Link to="/dashboard" className="flex items-center gap-2 text-sm text-slate-500 hover:text-brand-navy" data-id="element-1424">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-1425" /> Back to dashboard
            </Link>
          </div>
          <Logo data-id="element-1426" />
          <div className="flex items-center gap-2" data-id="element-1427">
            <Button variant="outline" size="sm" data-id="element-1428">
              <CopyIcon className="w-4 h-4 mr-2" data-id="element-1429" /> Copy link
            </Button>
            <Button variant="outline" size="sm" data-id="element-1430">
              <QrCodeIcon className="w-4 h-4 mr-2" data-id="element-1431" /> QR code
            </Button>
            <Button variant="primary" size="sm" data-id="element-1432">
              <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-1433" /> Open in new tab
            </Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-10" data-id="element-1434">
        <div className="text-center mb-8" data-id="element-1435">
          <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-100 text-emerald-700 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-1436">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" data-id="element-1437" />
            Live · Leadership Reset Retreat
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-brand-navy mb-2" data-id="element-1438">
            Event Hub
          </h1>
          <p className="text-slate-600 max-w-xl mx-auto" data-id="element-1439">
            This is exactly what your 48 attendees see on their phones. Updates
            here go live to every participant in real time.
          </p>
        </div>

        <ParticipantPreview data-id="element-1440" />

        <div className="grid sm:grid-cols-3 gap-4 mt-8 max-w-3xl mx-auto" data-id="element-1441">
          <div className="bg-white rounded-xl border border-slate-100 p-5 text-center" data-id="element-1442">
            <div className="text-2xl font-black text-brand-navy" data-id="element-1443">42 / 48</div>
            <div className="text-xs text-slate-500 font-medium mt-1" data-id="element-1444">
              Participants active right now
            </div>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-5 text-center" data-id="element-1445">
            <div className="text-2xl font-black text-brand-teal" data-id="element-1446">87%</div>
            <div className="text-xs text-slate-500 font-medium mt-1" data-id="element-1447">
              Hub engagement today
            </div>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-5 text-center" data-id="element-1448">
            <div className="text-2xl font-black text-brand-coral" data-id="element-1449">24</div>
            <div className="text-xs text-slate-500 font-medium mt-1" data-id="element-1450">
              Reflections submitted
            </div>
          </div>
        </div>
      </div>
    </div>;
}